import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-chevron-down',
  templateUrl: './icon-chevron-down.component.html',
  styleUrls: ['./icon-chevron-down.component.scss'],
})
export class IconChevronDownComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}
}
